"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LawType = void 0;
var LawType;
(function (LawType) {
    LawType["JBA"] = "JBA";
    LawType["JBL"] = "JBL";
    LawType["LEGIARTI"] = "LEGIARTI";
})(LawType || (exports.LawType = LawType = {}));
//# sourceMappingURL=lawTexts.js.map